// extracted by mini-css-extract-plugin
export default {"container":"LoadForm_container__KZNsf","wrapper":"LoadForm_wrapper__p0HrJ","button":"LoadForm_button__maTyW","accent":"LoadForm_accent__hivxV","pressed":"LoadForm_pressed__-XVDa"};